import { NavArrowDown } from 'iconoir-react'
import { useState } from 'react'

const DropDown = ({items, defaultSelect, onSelect, selected, prefix}) => {
	const [state, setState] = useState('hidden')

	const handleItemClick = (e) => {
		onToggle();
		onSelect(e.target.innerText);
	}

	const onToggle = () => {
		if(state === '') setState('hidden')
		else setState('')
	}

  return (
    <div className="relative w-full inline-block text-left">
    <div>
      <button type="button" onClick={onToggle} className="space-x-4 border text-sm border-gray-400 bg-white dark:bg-gray-800 shadow-sm flex justify-between items-center w-full rounded-md px-4 py-2 text-md font-medium text-gray-600 dark:text-gray-50 hover:bg-gray-50 dark:hover:bg-gray-500 focus:outline-none" id="options-menu">
        <span> { selected === '' ? defaultSelect: selected}</span>
        <NavArrowDown />
      </button>
    </div>
    <div className={`origin-top-right ${state} z-30 w-full absolute right-0 mt-1 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5`}>
        {items && items.map((item, index)=>{
          return (<button key={index} type='button' onClick={handleItemClick} className="flex w-full items-center px-4 py-2 text-md text-gray-700 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-100 dark:hover:text-white dark:hover:bg-gray-600" role="menuitem">
            <span className="flex text-sm w-full text-center flex-col">
              {prefix} {item}
            </span>
          </button>)
        })}
    </div>
</div>
  )
}

export default DropDown